import {t} from "ftc-common/i18n";
import Counter from 'ftc-common/ref/components/Counter'
import Toggle from 'ftc-common/ref/components/Toggle'
import {AllianceColor, ArtifactType, BiobuzzScoringElement, DecodeTeleopBaseLocation} from "ftc-common/javaTypes";
import {calculateScoreBreakdown, defaultScore, ScoreType, ScoreTypeSetValue} from "./Biobuzz/scores";
import {ScoreCalculatorSeason} from "../season";
import BiobuzzScoringElementRenderer from "ftc-common/season/biobuzz/BiobuzzScoringElementRenderer";

const robotArr = [1, 2] as const;

const flowerFields = ['redAllianceFlower', 'blueAllianceFlower', 'audienceFlower', 'scoringFlower'] as const;

const flowerNames = {
    'redAllianceFlower': 'Red Alliance FLOWER',
    'blueAllianceFlower': 'Blue Alliance FLOWER',
    'audienceFlower': 'Audience FLOWER',
    'scoringFlower': 'Scoring FLOWER',
}

function Flower({ score, setScoreValue, field }: { score: ScoreType, setScoreValue: ScoreTypeSetValue, field: typeof flowerFields[number] }) {
    const current = score[field]
    const reversed = [...current].reverse();

    return <div className="col-12 col-sm-10 col-lg-5">
        <span>{flowerNames[field]}</span>
        <br/>
        <button className={"btn btn-sm btn-red my-1 ms-1"} onClick={() => setScoreValue(field, [...current, BiobuzzScoringElement.RED_NECTAR])}>+ Red</button>
        <button className={"btn btn-sm btn-blue my-1 ms-1"} onClick={() => setScoreValue(field, [...current, BiobuzzScoringElement.BLUE_NECTAR])}>+ Blue</button>
        <button className={"btn btn-sm btn-warning my-1 mx-1"} onClick={() => setScoreValue(field, [...current, BiobuzzScoringElement.POLLEN])}>+ POLLEN</button>
        <br/>
        {/*TODO better rendering*/}
        {reversed.map((v, idx) => <div key={idx}>
            <BiobuzzScoringElementRenderer value={v}/>
            <button className={"btn btn-sm btn-secondary ms-1 mb-1"} onClick={() => setScoreValue(field, [...current.slice(0, current.length - 1 - idx), ...current.slice(current.length - idx)])}><i className={"fa fa-x"}></i></button>
        </div>)}
    </div>
}

function ScoreBreakdown({ score } : { score: ScoreType }) {
    return <div className={"col-12 col-sm-10"}>
        <table className={"table table-bordered table-sm horizontalBreakout text-center"} style={{tableLayout: 'fixed'}}>
            <thead>
            <tr>
                <th>{t`AUTO`}</th>
                <th>{t`TELEOP`}</th>
                <th>{t`FOUL`}</th>
                <th colSpan={3}>{t`RP`}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td rowSpan={2}>{score.autoPoints}</td>
                <td rowSpan={2}>{score.teleopPoints}</td>
                <td rowSpan={2}>{score.foulPointsCommitted}<br/>{t`(to other alliance)`}</td>
                <th>SWARM</th>
                <th>POLLINATOR 1</th>
                <th>POLLINATOR 2</th>
            </tr>
            <tr>
                <td><i className={`fa fa-${score.swarmRP ? 'check' : 'x'}`}></i> ({score.swarmRPProgress[0]}/{score.swarmRPProgress[1]})</td>
                <td><i className={`fa fa-${score.pollinator1RP ? 'check' : 'x'}`}></i> ({score.pollinator1RPProgress[0]}/{score.pollinator1RPProgress[1]})</td>
                <td><i className={`fa fa-${score.pollinator2RP ? 'check' : 'x'}`}></i> ({score.pollinator2RPProgress[0]}/{score.pollinator2RPProgress[1]})</td>
            </tr>
            </tbody>
        </table>
        <details className={"verticalBreakout"}>
            <summary>Score details</summary>

            <table className={"table table-bordered table-sm text-center"} style={{tableLayout: 'fixed'}}>
                <tbody>
                <tr>
                    <th>{t`AUTO`}</th>
                    <td colSpan={2}>{score.autoPoints}</td>
                </tr>
                <tr>
                    <th>{t`TELEOP`}</th>
                    <td colSpan={2}>{score.teleopPoints}</td>
                </tr>
                <tr>
                    <th>{t`FOUL`}</th>
                    <td colSpan={2}>{score.foulPointsCommitted} {t`(to other alliance)`}</td>
                </tr>
                <tr>
                    <th colSpan={3}>{t`RP`}</th>
                </tr>
                <tr>
                    <th>SWARM</th>
                    <th>POLLINATOR 1</th>
                    <th>POLLINATOR 2</th>
                </tr>
                <tr>
                    <td><i className={`fa fa-${score.swarmRP ? 'check' : 'x'}`}></i> ({score.swarmRPProgress[0]}/{score.swarmRPProgress[1]})</td>
                    <td><i className={`fa fa-${score.pollinator1RP ? 'check' : 'x'}`}></i> ({score.pollinator1RPProgress[0]}/{score.pollinator1RPProgress[1]})</td>
                    <td><i className={`fa fa-${score.pollinator2RP ? 'check' : 'x'}`}></i> ({score.pollinator2RPProgress[0]}/{score.pollinator2RPProgress[1]})</td>
                </tr>
                </tbody>
            </table>
        </details>
    </div>
}

function Auto({score, setScoreValue, random} : {
    score: ScoreType,
    setScoreValue: ScoreTypeSetValue,
    random: number
}) {
    return <>
        <div className="row justify-content-center">
            <div className={"col-12 col-sm-10 col-lg-5 "}>
                <Counter
                    label={`HIVE Tips`}
                    limit={100} large={true}
                    value={score.autoHiveTips}
                    setValue={(val) => {
                        setScoreValue("autoHiveTips", val)
                    }} />
            </div>
        </div>

        {robotArr.map(num => <div key={num} className="row justify-content-center">
            <Toggle
                    label={`ROBOT ${num} LEAVE:`}
                    options={["No", "Yes"]} value={score[`autoRobot${num}Leave`] ? 1 : 0}
                    setValue={(val) => setScoreValue(`autoRobot${num}Leave`, val == 1)} />
            <Toggle
                    label={`ROBOT ${num} PARK:`}
                    options={["No", "Yes"]} value={score[`autoRobot${num}Park`] ? 1 : 0}
                    setValue={(val) => setScoreValue(`autoRobot${num}Park`, val == 1)} />
        </div>)}
    </>
}

function Teleop({score, setScoreValue, random}: {
    score: ScoreType,
    setScoreValue: ScoreTypeSetValue,
    random: number
}) {

    return <>
        <div className="row justify-content-center">
            <div className={"col-12 col-sm-10 col-lg-5 "}>
                <Counter
                      label={`HIVE Tips`}
                      limit={100} large={true}
                      value={score.teleopHiveTips}
                      setValue={(val) => {
                          setScoreValue("teleopHiveTips", val)
                      }} />
            </div>
        </div>
        <div className="row justify-content-center">
            {flowerFields.map(field => <Flower key={field} score={score} setScoreValue={setScoreValue} field={field} />)}
        </div>

        <div className="row justify-content-center">
            {robotArr.map(num =>
                    <Toggle key={num}
                            label={`ROBOT ${num} PARK:`}
                            options={["No", "Yes"]} value={score[`teleopRobot${num}Park`] ? 1 : 0}
                            setValue={(val) => setScoreValue(`teleopRobot${num}Park`, val == 1)} />
            )}
        </div>

        <div className="row justify-content-center">
            <div className={"col-12 col-sm-10 col-lg-5 "}>
                <Counter
                      label={`Remaining HIVE POLLEN/NECTAR`}
                      limit={100}
                      value={score.teleopHivePollenNectar}
                      setValue={(val) => {
                          setScoreValue("teleopHivePollenNectar", val)
                      }} />
                <Counter
                    label={`GARDEN POLLEN/NECTAR`}
                    limit={100}
                    value={score.teleopGardenPollenNectar}
                    setValue={(val) => {
                        setScoreValue("teleopGardenPollenNectar", val)
                    }} />
            </div>
        </div>
    </>
}

function Penalties({score, setScoreValue}: {
    score: ScoreType,
    setScoreValue: ScoreTypeSetValue,
}) {
    return <>
        <div className="row justify-content-center">
            <Counter className={"col-12 col-sm-10 col-lg-5"} label={t`MINOR FOULS:`} value={score.minorFouls}
                     setValue={(val) => setScoreValue('minorFouls', val)}/>
            <Counter className={"col-12 col-sm-10 col-lg-5"} label={t`MAJOR FOULS:`} value={score.majorFouls}
                     setValue={(val) => setScoreValue('majorFouls', val)}/>
        </div>
    </>
}

function validationErrors(
    score: ScoreType
) {
    const errors = []
    for (const field of Object.keys(score) as (keyof ScoreType)[]) {
        if(typeof score[field] == 'number' && score[field] < 0) {
            errors.push(`Negative value for ${field} alliance`);
        }
    }
    return errors;
}

const BiobuzzSeason : ScoreCalculatorSeason<ScoreType> = {
    name: 'BIOBUZZ',
    allianceSpecific: true,
    ScoreBreakdown,
    Auto,
    Teleop,
    Penalties,
    validationErrors,
    calculateScoreBreakdown,
    defaultScore
}

export default BiobuzzSeason;